import { $, _ } from "../../../../helpers/dom-selectors.js";
import makeDiscountForm from "./discount-form.js";
const discountForm = makeDiscountForm({
    form: $(document, '.form')[0],
    overlayEl: _('resultOverlay')
});
const APP_COMPONENTS = Object.freeze({
    discountForm
});
export default APP_COMPONENTS;
